import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { updateUser as updateUserApi } from "../api/users.api";
import type { UserItem, UserUpdateRequest } from "../types/user.types";

export interface UseUpdateUserReturn {
  updateUser: (id: string, request: UserUpdateRequest) => Promise<UserItem>;
  loading: boolean;
  error: string | null;
}

export function useUpdateUser(): UseUpdateUserReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const update = useCallback(async (id: string, request: UserUpdateRequest) => {
    setLoading(true);
    setError(null);
    try {
      return await updateUserApi(id, request);
    } catch (requestError: unknown) {
      setError(getApiErrorMessage(requestError, "Failed to update user"));
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);
  return { updateUser: update, loading, error };
}
